import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCurrentClientMembershipTypeId_session$key } from "./__generated__/useCurrentClientMembershipTypeId_session.graphql";

export const useCurrentClientMembershipTypeId = (
  sessionRef: useCurrentClientMembershipTypeId_session$key
) => {
  const session = useFragment(
    useCurrentClientMembershipTypeIdFragmentString,
    sessionRef
  );
  return session.currentClientProfile?.member?.membershipType?.id;
};

const useCurrentClientMembershipTypeIdFragmentString = graphql`
  fragment useCurrentClientMembershipTypeId_session on Session {
    currentClientProfile {
      member {
        membershipType {
          id
        }
      }
    }
  }
`;
